import { Button } from '@design-system/Button';
import React from 'react';
import { CartSummary } from '../style';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';
import { usePaystackPayment } from 'react-paystack';
import { useSelector } from 'react-redux';
import { getUser } from '@app/auth/redux/selectors';
import { useDispatch } from 'react-redux';
import { delete_product_from_basket } from '@app/basket/redux/reducer';
import { AiOutlineDelete } from 'react-icons/ai';

const Summary = ({
  cart,
  totalPrice,
  subtotal,
  serviceFee,
  deliveryFee,
  handleSubmit,
  canCheckout,
  error,
  creating,
}) => {
  const user = useSelector(getUser);
  const dispatch = useDispatch();

  const config = {
    email: user?.email,
    amount: subtotal * 100,
    currency: totalPrice?.short_code,
    publicKey: process.env.REACT_APP_PAYSTACK_PK,
  };

  const componentProps = {
    ...config,
    metadata: {
      user_id: user?._id,
    },
  };

  const initializePayment = usePaystackPayment(componentProps);

  const onSuccess = (response) => {
    handleSubmit(response);
  };

  const handleDelete = (doc) => {
    dispatch(delete_product_from_basket(doc));
  };

  return (
    <CartSummary>
      <div className="header">basket summary</div>
      <div className="body">
        {/* products */}
        <div>
          {cart.map((data) => (
            <div className="products" key={data._id}>
              <div className="card">
                <img
                  src={data?.product?.image}
                  alt={data?.product?.name}
                  className="image"
                />

                <div className="content">
                  <h3>
                    {data?.product?.name} - {data?.net_weight} {data?.product?.unit}
                  </h3>
                  <h4>{`${data?.price?.currency?.symbol}${commaNumber(
                    data?.price?.value,
                  )}`}</h4>
                  <h5>Qty: {data?.quantity}</h5>
                </div>

                <div className="delete" onClick={() => handleDelete(data._id)}>
                  <AiOutlineDelete size={25} color="#D92D20" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* products end */}
        <div className="summary_total">
          <div className="sub_total">
            <h4>Order Total</h4>
            <h5>
              {totalPrice.currency}
              {commaNumber(totalPrice.total_price)}
            </h5>
          </div>

          <div className="sub_total">
            <h4>Delivery Fee</h4>
            <h5>
              {totalPrice.currency}
              {commaNumber(deliveryFee)}
            </h5>
          </div>

          <div className="sub_total">
            <h4>Payment Charge</h4>
            <h5>
              {' '}
              {totalPrice.currency}
              {commaNumber(serviceFee)}
            </h5>
          </div>
        </div>

        <div className="total">
          <h4>Sub Total</h4>
          <h5>
            {totalPrice.currency}
            {commaNumber(subtotal)}
          </h5>
        </div>

        {/* <div
          className="coupon"
          // style={{ display: 'flex', gap: '20px', alignItems: 'center' }}
        >
          <input type="text" placeholder="Coupon Code" onChange={handleCoupon} />
          <Button
            text={'Apply'}
            bgColor="#549A9A"
            weight="500"
            width="100%"
            onClick={applyCoupon}
          />
        </div> */}

        <Button
          width="100%"
          text={creating ? 'Processing Payment' : 'Proceed to payment'}
          bgColor="#549A9A"
          weight="500"
          mb="10px"
          onClick={() => {
            initializePayment(onSuccess);
          }}
          disabled={canCheckout() || creating}
        />
        <div
          style={{
            color: 'red',
            textAlign: 'center',
            fontWeight: '600',
            marginBottom: '35px',
          }}
        >
          {error}
        </div>
      </div>
    </CartSummary>
  );
};

export default Summary;

Summary.propTypes = {
  cart: PropTypes.array.isRequired,
  totalPrice: PropTypes.object.isRequired,
  subtotal: PropTypes.number.isRequired,
  serviceFee: PropTypes.number.isRequired,
  deliveryFee: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  canCheckout: PropTypes.func.isRequired,
  creating: PropTypes.bool.isRequired,
};
